﻿import common = require("../../../common");
import Vue from 'vue';
import Component from 'vue-class-component';
import core = require("../../../core");
import HotEditableFormManager = require("./HotEditableFormManager");
import HotEditableSelectComponent = require("./HotEditableSelectComponent");
import SharedHotEditableParentForm = require("./SharedHotEditableParentForm");
import HotEditableMessageComponent = require("./HotEditableMessageComponent");
import AjaxService = require('../../../services/AjaxService');
import context = require("../../context");
import HotEditableFormAction = require("./HotEditableFormAction");
import HotEditableHelpers = require("./HotEditableHelpers");
import utilities = require("../../utilities");

// Fonction éxécutée pour obtenir le template du contrôle (définie dans _HotEditableSelectVueComponent.cshtml)
declare function __getHotEditableDoubleSelectsComponentTemplate(): string;

interface IHotEditableDoubleSelectApiArguments {
    selectedOptionValue1?: string;
    selectedOptionValue2?: string;
    originalValue1?: string;
    originalValue2?: string;
    field2IsFullIfField1IsEmpty?: boolean;
    isForm?: boolean;
    idEntity?: string;
    clickedFieldNumber?: number;
}

interface IFetchCallbackStruc {
    callback?: () => void;
    mustRun: boolean;
}

enum fieldSizes {
    unknown,
    small,
    medium,
    large,
    xlarge
}

@Component({
    props:
    {
        // Props (attributs sur le tag HTML initial) (les props sont préfixées par 'init' dans prepareMarkup())
        initId: String,
        initName: String,
        initClass1: String,
        initClass2: String,
        initValue1: String,
        initValue2: String,
        initTabIndex: Number,
        initLabel1: String,
        initLabel2: String,
        initDisplayName1: String,
        initDisplayName2: String,
        initPlaceholder1: String,
        initPlaceholder2: String,
        initRequired1: String,
        initRequired2: String,
        initClearable: Boolean,
        initDisabled: Boolean,
        initDefaultValue1: String,
        initDefaultValue2: String,
        initApiUrl: String,
        initFieldsSize: String,
        initEditModeOn: Boolean,
        initCanChangeEditMode: Boolean,
        initField2IsFullIfField1IsEmpty: Boolean,
        initIsForm: Boolean,
        initIdEntity: String,
        initAutoSelectSecondaryField: Boolean,
        initAutoDisableSecondaryField: Boolean
    }
})
class HotEditableDoubleSelectsComponent extends Vue implements common.IHotEditableFieldComponent, common.IHotEditableFormParentVue {
    shared: SharedHotEditableParentForm;
    formMode: common.HotEditableFormModes;
    formManager: HotEditableFormManager;

    initId: string;
    initName: string;
    initClass1: string;
    initClass2: string;
    initValue1: string;
    initValue2: string;
    initTabIndex: number;
    initLabel1: string;
    initLabel2: string;
    initDisplayName1: string;
    initDisplayName2: string;
    initRequired1: string;
    initRequired2: string;
    initPlaceholder1: string;
    initPlaceholder2: string;
    initClearable: boolean;
    initDisabled: boolean;
    initDefaultValue1: string;
    initDefaultValue2: string;
    initApiUrl: string;
    initFieldsSize: string;
    initEditModeOn: boolean;
    initCanChangeEditMode: boolean;
    initField2IsFullIfField1IsEmpty: boolean;
    initIsForm: boolean;
    initIdEntity: string;
    initAutoSelectSecondaryField: boolean;
    initAutoDisableSecondaryField: boolean;

    rootId: string;
    idElement: string;
    idElement1: string;
    idElement2: string;
    elementValue: string;
    elementName: string;
    elementName1: string;
    elementName2: string;
    cssClass1: string;
    cssClass2: string;
    tabIndex: number;
    tabIndex1: number;
    tabIndex2: number;
    required1: string;
    required2: string;
    clearable: boolean;
    disabled: boolean;
    label1: string;
    label2: string;
    defaultValue1: string; //Valeur affiché en mode lecture (label) quand aucune valeur de sélectionnée.
    defaultValue2: string; //Valeur affiché en mode lecture (label) quand aucune valeur de sélectionnée.
    displayName1: string; //Champ utilisé pour identifier le champ lors des messages aux utilisateurs.
    displayName2: string; //Champ utilisé pour identifier le champ lors des messages aux utilisateurs.
    placeholder1: string; //Message affiché quand le champ n'a pas de sélection en mode edition.
    placeholder2: string; //Message affiché quand le champ n'a pas de sélection en mode edition.
    editModeOn: boolean;
    canChangeEditMode: boolean;
    originalValue1: string;
    originalValue2: string;
    apiUrl: string;
    fieldsSize: fieldSizes;
    hasError: boolean;
    isForm: boolean;
    field2IsFullIfField1IsEmpty: boolean;
    fieldType = common.HotEditableFieldTypes.doubleSelect;
    idEntity: string;
    autoSelectSecondaryField: boolean;
    autoDisableSecondaryField: boolean;
    isParent = true;

    //messages
    messageId1: string;
    messageId2: string;
    messageClass1: string;
    messageClass2: string;
    messageFieldName1: string;
    messageFieldName2: string;
    ignoreInnerAction: boolean;
    isInitialLoading: boolean;

    // Privates props (doivent etre expose en public pour que ces props soient transferees dans le VueClassComponent)
    _field1: HotEditableSelectComponent;
    _field2: HotEditableSelectComponent;
    _previousValue1 = null as any;
    _previousValue2 = null as any;
    _formManagerParent: HotEditableFormManager;//NOTE: Doit undefined initialement car il est definie dans le "beforeCreate"
    _ajaxService: AjaxService;
    _fetchCallbackStruc: IFetchCallbackStruc;

    static tagName = "hoteditabledoubleselects";

    static defaultValue() {
        return HotEditableDoubleSelectsComponent.toMergedTextValue();
    }

    data() {
        const guid = utilities.createGuid('N');
        const id = this.initId || "Field_" + guid;
        const name = this.initName || id;
        const tabIndex = this.initTabIndex || -1;
        // inner ids
        const field1Id = id + "_1";
        const field2Id = id + "_2";
        // inner names
        const field1Name = name + "_1";
        const field2Name = name + "_2";
        const o = {
            rootId: "HotEditableField_" + guid,
            idElement: id,
            idElement1: field1Id,
            idElement2: field2Id,
            elementName: name,
            elementName1: field1Name,
            elementName2: field2Name,
            elementValue: HotEditableDoubleSelectsComponent.toMergedTextValue(this.initValue1, this.initValue2),
            editModeOn: this.initEditModeOn === true,
            canChangeEditMode: this.initCanChangeEditMode === true,
            apiUrl: this.initApiUrl || (() => { throw "L'URL de l'API est requis (attribut 'init-api-url')"; })(),
            cssClass1: this.initClass1 || '',
            cssClass2: this.initClass2 || '',
            tabIndex: tabIndex,
            tabIndex1: tabIndex + 1,
            tabIndex2: tabIndex + 2,
            label1: this.initLabel1 || '',
            label2: this.initLabel2 || '',
            required1: this.initRequired1,
            required2: this.initRequired2,
            displayName1: this.initDisplayName1 || null,
            displayName2: this.initDisplayName2 || null,
            placeholder1: this.initPlaceholder1 || '',
            placeholder2: this.initPlaceholder2 || '',
            clearable: this.initClearable === true,
            disabled: this.initDisabled === true,
            hasError: false,
            defaultValue1: this.initDefaultValue1 || '',
            defaultValue2: this.initDefaultValue2 || '',
            originalValue1: this.initValue1 || null,
            originalValue2: this.initValue2 || null,
            fieldsSize: this.initFieldsSize || fieldSizes.unknown,
            field2IsFullIfField1IsEmpty: this.initField2IsFullIfField1IsEmpty === true,
            isForm: this.initIsForm === true,
            // Messages
            messageId1: field1Id + "Message",
            messageId2: field2Id + "Message",
            messageFieldName1: field1Name,
            messageFieldName2: field2Name,
            messageClass1: null,
            messageClass2: null,
            isInitialLoading: true,
            ignoreInnerAction: true,
            idEntity: this.initIdEntity || null,
            clickedFieldNumber: null as number,
            autoSelectSecondaryField: this.initAutoSelectSecondaryField === true,
            autoDisableSecondaryField: this.initAutoDisableSecondaryField === true,
            _fetchCallback: null as any
        };

        return o;
    }

    // Fonction système exécutée automatiquement AVANT le constructeur (!!!)
    beforeCreate() {
        this._fetchCallbackStruc = {
            callback: null as () => void,
            mustRun: false
        } as IFetchCallbackStruc;

        this._formManagerParent = ((this.$parent as any).formManager as HotEditableFormManager).registerField(this);

        const formName = this._formManagerParent.getFormName();
        this.formManager = new HotEditableFormManager(this, formName).setFocusCallbacksFromField(
            () => this._formManagerParent.focusPreviousComponentFromField(this),
            () => this._formManagerParent.focusNextComponentFromField(this));

        this.shared = new SharedHotEditableParentForm(this.formManager).setActionCallback(a => {
            this.onInnerFormChange(a);
        });

        const c = {};
        c[HotEditableSelectComponent.tagName] = HotEditableSelectComponent;
        c[HotEditableMessageComponent.tagName] = HotEditableMessageComponent;
        this.$options.components = c;
        this.$options.template = __getHotEditableDoubleSelectsComponentTemplate();
    }

    created() {
    }

    mounted() {
        HotEditableHelpers.validateFieldSettings(this);

        (this.$el as Element).removeAttribute("hot-editable-cloak");

        this._ajaxService = new AjaxService();
        this._field1 = this.formManager.getFieldByName(this.elementName1) as HotEditableSelectComponent;
        this._field2 = this.formManager.getFieldByName(this.elementName2) as HotEditableSelectComponent;

        this.updateInnerFields();
    }

    getChildElementValue(fieldNumber: number) {
        if (!fieldNumber)
            throw "L'argument 'fieldNumber' est requis et doit etre correspondre a 1 ou a 2";

        if (fieldNumber === 1)
            return this._field1.getTextualValue();
        else if (fieldNumber === 2)
            return this._field2.getTextualValue();
        throw "L'argument 'fieldNumber' doit être 1 ou 2.";
    }

    setPreviousValue(value?: string[]) {
        if (!value || value.length < 1)
            return this;
        this._field1.updatePreviousValue(value[0]);
        if (value.length < 2)
            return this;
        this._field2.updatePreviousValue(value[1]);
        return this;
    }

    changeMode(canChangeEditMode: boolean, editModeOn: boolean) {
        this.setPreviousValue();
        this.canChangeEditMode = canChangeEditMode;
        this.editModeOn = editModeOn;

        this._field1.changeMode(canChangeEditMode, editModeOn);
        this._field2.changeMode(canChangeEditMode, editModeOn);

        return this;
    }

    private innerSetFromTextualValue(textualValue: string) {
        const unmerged = HotEditableDoubleSelectsComponent.fromMergedTextValue(textualValue);

        this._fetchCallbackStruc.mustRun = true;
        this._fetchCallbackStruc.callback = () => {
            this._field2.setFromTextualValue(unmerged[1]).changed();
        };

        this._field1.setFromTextualValue(unmerged[0]).changed();
    }

    setFromTextualValue(textualValue?: string) {
        this.elementValue = textualValue;

        if (this.isInitialLoading) {
            this._fetchCallbackStruc.mustRun = true;
            this._fetchCallbackStruc.callback = () => { this.innerSetFromTextualValue(textualValue); };

            return this;
        }

        this.innerSetFromTextualValue(textualValue);

        return this;
    }

    getTextualValue() {
        const t1 = this._field1.getTextualValue();
        const t2 = this._field2.getTextualValue();
        const merged = HotEditableDoubleSelectsComponent.toMergedTextValue(t1, t2);

        return merged;
    }

    onChanged(event: Event) {
        this.preventDefault(event);
        this.changed();
    }

    onCancel(event: Event) {
        this.preventDefault(event);
        this.cancel();
    }

    onClear(event: Event) {
        this.preventDefault(event);
        this.clear();
    }
    clear() {
        this._field1.clear();
        this._field2.clear();
    }

    // Fonction éxécutée lorsque l'utilisateur clique sur le bouton d'annulation de l'édition
    cancel() {
        this._field1.cancel();
        this._field2.cancel();
    }

    private preventDefault(e?: Event, bypassStopPropagation?: boolean) {
        if (!e)
            return;

        e.preventDefault();

        if (bypassStopPropagation !== true)
            e.stopPropagation();
    }

    // Fonction éxécutée lorsque l'utilisateur effectue un choix dans la liste déroulante (from: vue-select)
    changed() {
        this.elementValue = this.getTextualValue();
        this.$nextTick(() => {
            this._formManagerParent.fieldChanged(this);
        });
    }

    // Fonction éxécutée lorsque l'utilisateur clique sur le bouton d'édition
    editClick(event?: Event, forcedMode?: boolean, fromPrevious?: boolean) {
        fromPrevious = fromPrevious === true;
        if (fromPrevious)
            this._field2.editClick(event, forcedMode);
        else
            this._field1.editClick(event, forcedMode);
    }

    onEnterClick(event?: KeyboardEvent) {
        //do nothing
    }

    onEscapeClick(event?: KeyboardEvent) {
        //do nothing
    }

    onTabClick(event?: KeyboardEvent) {
        //do nothing
    }

    onShiftTabClick(event?: KeyboardEvent) {
        //do nothing
    }

    onBlur(event?: Event) {
        //do nothing
    }

    blur() {
        this.changed();
        //setTimeout(() => { this.changed(true); }, 250);
    }

    focus(fromPrevious?: boolean) {
        fromPrevious = fromPrevious === true;
        if (fromPrevious)
            this._field2.focus();
        else
            this._field1.focus();
    }

    private onInnerFormChange(action: HotEditableFormAction) {

        this.$nextTick(() => {
            if (this.ignoreInnerAction)
                return;

            this.ignoreInnerAction = true;

            if (action.getFieldName() === this.elementName1)
                this.updateInnerFields(1);
            else if (action.getFieldName() === this.elementName2)
                this.updateInnerFields(2);
        });
    }

    private updateInnerFields(fieldNumber?: number) {

        const a = {
            selectedOptionValue1: this.getInnerFieldValue(1),
            selectedOptionValue2: this.getInnerFieldValue(2),
            originalValue1: this.originalValue1,
            originalValue2: this.originalValue2,
            idEntity: this.idEntity,
            clickedFieldNumber: fieldNumber || null,//null signifie le call initial
            field2IsFullIfField1IsEmpty: this.field2IsFullIfField1IsEmpty,
            isForm: this.isForm
        } as IHotEditableDoubleSelectApiArguments;

        this.fetchSelectsOptions(a);
    }

    private fetchSelectsOptions(args: IHotEditableDoubleSelectApiArguments) {

        const onError = (errors?: common.IError[], config?: common.IHotEditableFormConfig) => {
            errors = errors && errors.length ? errors : [new core.Error("Une erreur c'est produite lors de la collect des données.")];
            HotEditableDoubleSelectsComponent.displayError(errors[0]);
        };

        this._ajaxService.post(this.apiUrl, args, true, data => {

            if (!data) {
                onError();
                return;
            }

            const o1 = data.options1 as common.ISelectOption[];
            const o2 = data.options2 as common.ISelectOption[];
            const mustUpdatePreviousValue = !this.isInitialLoading;

            this.updateSelectOptions(1, o1, mustUpdatePreviousValue);
            this.updateSelectOptions(2, o2, mustUpdatePreviousValue);

            this.ignoreInnerAction = false;

            if (this._fetchCallbackStruc.mustRun) {
                this._fetchCallbackStruc.mustRun = false;

                this.$nextTick(() => {
                    if (this._fetchCallbackStruc.callback)
                        this._fetchCallbackStruc.callback();
                });
            }

            if (this.isInitialLoading)
                this.isInitialLoading = false;
            else
                this.changed();

        }, onError);
    }

    private getInnerFieldValue(fieldNumber: number) {
        const f = this.getInnerFieldByNumber(fieldNumber);

        if (this.isInitialLoading)
            return f.elementValue || null;

        return f.elementValue ? (f.elementValue as common.IHotEditableSelectOption).code : null;
    }

    private getInnerFieldByNumber(fieldNumber: number) {
        if (fieldNumber === 1)
            return this._field1 as HotEditableSelectComponent;
        else if (fieldNumber === 2)
            return this._field2 as HotEditableSelectComponent;

        throw "L'argument 'fieldNumber' est requis et doit correspondre a 1 ou a 2.";
    }

    private updateSelectOptions(fieldNumber: number, options?: common.ISelectOption[], updatePreviousValue?: boolean) {
        updatePreviousValue = updatePreviousValue === true;

        const r = HotEditableHelpers.convertToVueSelectOptions(options);
        const f = this.getInnerFieldByNumber(fieldNumber);

        f.options = r.options;

        if (fieldNumber === 2) {

            if (this.autoDisableSecondaryField)
                f.disabled = !r.options.length;

            if (this.autoSelectSecondaryField && r.options.length === 1)
                r.selectedValue = r.options[0];
        }

        if (r.selectedValue)
            f.elementValue = r.selectedValue;
        else
            f.clear();

        if (updatePreviousValue)
            f.updatePreviousValue();
    }

    private static displayError(error: common.IError) {
        const manager = context.components.getMessagesManager();
        const m = {
            title: error.message,
            contentHtml: '',
            autoClose: false,
            messageSource: 'HotEditableDoubleSelectsComponent',
            messageType: common.MessageTypes.error
        } as common.IMessage;

        manager.displayMessage(m, true);
    }

    private static toMergedTextValue(textualValue1?: string, textualValue2?: string) {
        const textValueDelimiter = context.url.delimiters.valueDelimiter;
        const unsetTextualValueKeyword = context.url.values.emptyValueKey;
        var merged = '';
        const append = (t: string) => {
            if (merged)
                merged += textValueDelimiter;
            merged += t || unsetTextualValueKeyword;
        };

        append(textualValue1);
        append(textualValue2);

        return merged;
    }

    private static fromMergedTextValue(mergedTextualValue?: string) {
        const textValueDelimiter = context.url.delimiters.valueDelimiter;
        const unsetTextualValueKeyword = context.url.values.emptyValueKey;
        const unmerged = (mergedTextualValue || '').split(textValueDelimiter);

        for (let i = 0; i < unmerged.length; i++)
            if (unmerged[i].trim() === unsetTextualValueKeyword)
                unmerged[i] = null;

        return unmerged;
    }
}

export = HotEditableDoubleSelectsComponent;